import AdvisorDashboardLayout from '@/components/home/advisor/AdvisorDashboardLayout';
import { useGetUser } from '@/hooks/requests/useUser';
import { useAuthUser } from '@/hooks/stores/useAuthUser';
import { Card, Typography } from '@mui/material';

export default function Home() {
  const { isStaff } = useAuthUser();
  const { user } = useGetUser();

  if (isStaff) {
    return (
      <Card>
        <Typography variant="h4" component="h1" fontWeight="bold">
          Welcome {user?.firstName}
        </Typography>
      </Card>
    );
  }

  return <AdvisorDashboardLayout />;
}
